import React from 'react'
import type { WithStyles, AccordionProps } from '@material-ui/core'
import { withStyles, createStyles, Accordion } from '@material-ui/core'

export const styles = createStyles({
  root: {
    background: 'transparent',
    '&:before': {
      display: 'none'
    },
    '&.Mui-expanded': {
      margin: 0
    }
  },
  disabled: {
    '&.Mui-disabled': {
      backgroundColor: 'transparent'
    }
  }
})

export interface ExpansionPanelProps extends Omit<AccordionProps, 'classes'>, WithStyles<typeof styles> {}

function ExpansionPanel(props: ExpansionPanelProps) {
  const { classes, ...baseProps } = props
  return <Accordion {...baseProps} elevation={0} classes={classes} />
}

export default withStyles(styles)(ExpansionPanel)
